module.exports = __webpack_public_path__ + "img/dog.d24509ad.svg";